import { AiFillHome } from 'react-icons/ai'
import { IoSchoolSharp } from 'react-icons/io5'
import { FaStar } from 'react-icons/fa'
import { FaTools } from 'react-icons/fa'
import { FaQuestionCircle } from 'react-icons/fa'
import { FaInfoCircle } from 'react-icons/fa'
import { FaUserCheck } from 'react-icons/fa'

const internshipFloatingNavData = [
    { id: 1, link: '/', icon: <AiFillHome /> },
    { id: 2, link: '#header', icon: <IoSchoolSharp /> },
    { id: 3, link: '#highlights', icon: <FaStar /> },
    { id: 4, link: '#tools', icon: <FaTools /> },
    { id: 5, link: '#why', icon: <FaQuestionCircle /> },
    { id: 6, link: '#program-details', icon: <FaInfoCircle /> },
    { id: 7, link: '#who', icon: <FaUserCheck /> }
]

export default internshipFloatingNavData